class TakeoverMobile {
    constructor(element) {
        this.element = element;

        this.headerElement = document.querySelector(".js-header");
        this.mainContentsElement = document.querySelector(".js-main__contents");

        this.topElement = this.element.querySelector(".js-takeover__top");
        this.bottomElement = this.element.querySelector(".js-takeover__bottom");
    }

    setMainContentsMarginTop() {
        this.mainContentsElement.style.marginTop = 0;
    }

    // eslint-disable-next-line class-methods-use-this
    setBodyHeight() {
        document.body.style.height = `auto`;
    }

    setBodyMargin() {
        document.body.style.marginTop = `${this.topElement.clientHeight}px`;
        document.body.style.marginBottom = `${this.bottomElement.clientHeight}px`;
    }

    reposition() {
        this.setBodyHeight();
        this.setMainContentsMarginTop();
        this.setBodyMargin();
    }
}

export { TakeoverMobile };
